import { cn } from "@/lib/utils";
import React, { ReactNode } from "react";

export type MaxWidthDivProps = {
  externalClassName?: string;
  className?: string;
  children: ReactNode;
  id?: string;
};

export default function MaxWidthDiv(props: MaxWidthDivProps) {
  return props.externalClassName ? (
    <div className={cn(props.externalClassName)}>
      <div
        className={cn("max-w-[1400px] px-4 md:px-6 mx-auto", props.className)}
        id={props.id}
      >
        {props.children}
      </div>
    </div>
  ) : (
    <div
      className={cn("max-w-[1400px] px-4 md:px-6 mx-auto", props.className)}
      id={props.id}
    >
      {props.children}
    </div>
  );
}
